import Filters from '@/utils/input/filters';

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [CreatedDateFilter, UpdatedDateFilter];
